<!--
 * @Author: LZT
 * @Date: 2025-05-21 09:14:00
 * @LastEditors: LZT
 * @Description: 微信一键授权登录弹窗
-->
<template>
  <div class="wx-login">
    <van-popup
      z-index="2100"
      :show="showPopup"
      round
      position="bottom"
      closeable
      :close-icon="login_close_icon"
      @click-close-icon="closePopup"
    >
      <template #default>
        <div class="popup_content">
          <img class="login_logo" :src="app_logo" />
          <!-- 微信登录 -->
          <template v-if="loginType == 1">
            <div class="btn_box" :style="{'--opacity': checked ? '1' : '0.6'}" @click.stop.prevent="handleWeChatLogin">
              <img class="login_wx_icon" :src="login_wx_icon" />
              <div class="btn">微信一键登录</div>
            </div>
          </template>
          <!-- 账号密码登录 -->
          <template v-if="loginType == 2">
            <accountPasswordForm :checked="checked" @change:showTipsImg="showTipsImg = $event" />
          </template>
          <div class="tips_box">
            <van-checkbox
              v-model="checked"
              name="1"
              icon-size="17px"
              checked-color="#ec1539"
              @change="handleChecked"
            >
              <div class="login_checkbox_text">
                <div>我已阅读并同意</div>
                <div @touchstart.stop.prevent="goPage({ pageUrl: '/agreement/index' })">《用户协议》</div>和
                <div @touchstart.stop.prevent="goPage({ pageUrl: '/agreement/policy' })">《隐私政策》</div>
              </div>
            </van-checkbox>
            <img v-if="showTipsImg" class="login_tips_img" :src="login_tips_img" />
          </div>
          <div class="accountBox" @click="loginType == 1 ? loginType = 2 : loginType = 1">{{ loginType == 1 ? '账号密码登录' : '微信一键登录' }}</div>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script setup name="WxLogin">
import { defineProps, defineEmits, watch, onMounted, onUnmounted, getCurrentInstance } from "vue";
import accountPasswordForm from "./components/accountPasswordForm.vue";
import app_logo from "@/assets/images/login/app_logo.png";
import login_wx_icon from "@/assets/images/login/login_wx_icon.png";
import login_close_icon from "@/assets/images/login/login_close_icon.png";
import login_tips_img from "@/assets/images/login/login_tips_img.png";
import { loginReq, getAuthUrl } from "@/assets/js/request/api.js";
import { initiateWechatAuth } from "@/utils/wechatAuth";
import { openPage } from "@/utils/index";
import useUsersStore from "@/stores/user";
import { useAdhibitionStore } from "@/stores/adhibition";
import { setLocalStorage, getLocalStorage } from "@/utils";
import useRefreshStore from "@/stores/refresh";
import loginToWebSocket from "@/utils/webSocket/loginToWebSocket";
const adhibitionStore = useAdhibitionStore();
const userStore = useUsersStore();
const refreshStore = useRefreshStore();
const emit = defineEmits(["closeLoginPopup"]);

const props = defineProps({
  showPopup: {
    type: Boolean,
    default: false
  }
});
const checked = ref(false); // true勾选
const showTipsImg = ref(false); // 请先阅读并同意协议 背景图  true显示
const loginType = ref(1); // 1微信授权 2账号密码

// 微信一键登录 按钮点击
const handleWeChatLogin = () => {
  if (!checked.value) {
    showTipsImg.value = true;
    return;
  };
  // H5微信环境 微信服务号授权登录
  if (adhibitionStore.environment.isWeChat) {
    closePopup();
    handleWeChatAuth();
  };
  // app环境 走app微信sdk授权登录
  if (adhibitionStore.environment.isApp) {
    // uniapp调用微信授权登录
    window.postMessageToUniApp({
      type: "openWxLogin",
      msg: "使用微信授权登录",
    });
  };
};
// 微信授权登录
const handleWeChatAuth = async () => {
  const res = await getAuthUrl();
  if (res.code === 200 && res.authUrl) {
    // 使用工具函数发起微信授权
    initiateWechatAuth(res.authUrl);
  };
};
// 复选框change
const handleChecked = (event) => {
  showTipsImg.value = !event;
};
// 关闭弹窗
const closePopup = () => {
  userStore.setLoginPopup(false);
};
// 跳转页面
const goPage = (item) => {
  closePopup();
  openPage(item.pageUrl);
};

onMounted(() => {
  // H5浏览器环境 移动设备&&不是微信环境&&不是企业微信环境&&不是app环境 走账号登录
  if (
    adhibitionStore.environment.isMobile &&
    !adhibitionStore.environment.isWeChat &&
    !adhibitionStore.environment.isWeChatWork &&
    !adhibitionStore.environment.isApp
  ) {
    loginType.value = 2;
  };
});
</script>

<style lang="scss" scoped>
.wx-login {
  .popup_content {
    padding: 35px 20px 37px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .login_logo {
      width: 60px;
      height: 60px;
      display: block;
    }
    .btn_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(248, 15, 57, var(--opacity));
      border-radius: 6px;
      padding: 11px 0;
      margin-top: 41px;
      margin-bottom: 15px;
      .login_wx_icon {
        width: 26px;
        height: 26px;
        display: block;
      }
      .btn {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 16px;
        font-style: normal;
        margin-left: 7px;
      }
    }
    .tips_box {
      position: relative;
      .login_checkbox_text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        font-style: normal;
        div:nth-child(2),
        div:nth-child(3) {
          color: rgba(51, 51, 51, 1);
        }
      }
      .login_tips_img {
        width: 119px;
        height: 28px;
        display: block;
        position: absolute;
        bottom: -26px;
        left: 0;
      }
    }
    .accountBox {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #3185FF;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      padding: 28px 0 15px;
    }
  }
  .privacy_content {
    padding: 35px 20px 35px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    .decoration {
      color: rgba(15, 0, 218);
    }
    .privacy_btn {
      width: 100%;
      text-align: center;
      padding: 15px 0;
      color: rgba(41, 77, 183);
      &.agree {
        margin-top: 15px;
      }
    }
  }
}
</style>
